/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from app layout files.
// Do not edit it manually.

import * as layoutModule0 from "../../client/pages/convert/_layout/index";
import * as layoutModule1 from "../../client/pages/dev/_layout/index";
import * as layoutModule2 from "../../client/pages/employer/_layout/index";
import * as layoutModule3 from "../../client/pages/old/_layout/index";
import * as layoutModule4 from "../../client/pages/_layout/index";

const layouts = {
    "convert": layoutModule0,
    "dev": layoutModule1,
    "employer": layoutModule2,
    "old": layoutModule3,
    "": layoutModule4,
};

export const layoutOrder = [
    "convert",
    "dev",
    "employer",
    "old",
    "",
];

export default layouts;
